import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styles from './Input.module.scss';

const Input = ({
  name,
  value,
  type = 'text',
  multiline = false,
  theme = 'light',
  layout = 'standard',
  placeholder = '',
  textAlign = 'left',
  disabled = false,
  error = false,
  dataHook,
  onChange,
  className,
}) => {
  const mainClass = classNames({
    [styles.main]: true,
    [styles[`main--${theme}`]]: true,
    [styles[`main--${layout}`]]: true,
    [styles['main--error']]: error,
    [styles[`main--${theme}--error`]]: theme === 'dark' && error,
    [className]: true,
  });

  const onInputChange = useCallback((e) => {
    onChange({ name, value: e.target.value });
  }, [name, value]);

  return (
    multiline ?
      <textarea
        data-hook={dataHook}
        className={mainClass}
        placeholder={placeholder}
        name={name}
        type={type}
        value={value}
        disabled={disabled}
        onChange={onInputChange}
        style={{ textAlign }}
      />
      :
      <input
        data-hook={dataHook}
        className={mainClass}
        placeholder={placeholder}
        name={name}
        type={type}
        value={value}
        disabled={disabled}
        onChange={onInputChange}
        style={{ textAlign }}
      />
  );
};

Input.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.string,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  dataHook: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  layout: PropTypes.string,
  placeholder: PropTypes.string,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
};

export default Input;
